module.exports = __webpack_public_path__ + "img/first-avater-2@2x.bfe55a9.png";